<template>
  <section id="appMain" class="app-main">
    <router-view v-slot="{ Component, route }">
      <transition name="fade-transform" mode="out-in">
        <keep-alive>
          <component :is="Component" :key="route.path" v-if="route.meta.keepAlive" />
        </keep-alive>
      </transition>
      <transition name="fade-transform" mode="out-in">
        <component :is="Component" :key="route.path" v-if="!route.meta.keepAlive" />
      </transition>
    </router-view>
  </section>
</template>

<script>
export default {
  name: 'AppMain'
};
</script>

<style lang="scss" scoped>
.app-main {
  @include scrollBar;
  flex: 1;
  overflow-y: overlay;
  border-radius: $--border-radius-base;
}
</style>
